/**
 * @class Oskari.nba.bundle.nba-registers.service.RegistersSearchService
 */
Oskari.clazz.define('Oskari.nba.bundle.nba-registers.service.RegistersSearchService', function (instance) {
  this.instance = instance;
  this.sandbox = instance.getSandbox();
}, {
  _name: 'Oskari.nba.bundle.nba-registers.service.RegistersSearchService',
  getName: function getName() {
    return this._name;
  },
  init: function init() {},
  getRegistryItems: function getRegistryItems(params, successCb, errorCb) {
    var url = this.sandbox.getAjaxUrl();
    jQuery.ajax({
      dataType: 'json',
      type: 'POST',
      data: {
        action_route: 'GetRegistryItems',
        keyword: params.keyword,
        registries: params.registries,
        geometry: params.geometry
      },
      beforeSend: function beforeSend(x) {
        if (x && x.overrideMimeType) {
          x.overrideMimeType('application/json');
        }
      },
      url: url,
      error: errorCb,
      success: successCb
    });
  }
}, {
  protocol: ['Oskari.mapframework.service.Service']
});